import React from 'react';
import { TooltipButton } from 'components/common/tooltip/Tooltip';

export type CloseButtonProps = {
    closeModal: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const CloseButton: React.FunctionComponent<CloseButtonProps> = ({
    closeModal,
}) => (
    <TooltipButton
        type="button"
        onClick={(e) => closeModal(e)}
        tooltipId="close"
        variant="secondary"
        className="btn-xl btn-icon btn-flat-secondary"
    >
        <i className="icon" style={{ fontSize: '2rem' }}>
            close
        </i>
    </TooltipButton>
);
